import { Component, OnInit, Inject, Optional } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AppState } from '../../../../../store/reducers';
import { Store } from '@ngrx/store';
import { AlertService } from '../../../../../commons/services/alert.service';
import { Popups } from '../../../../../commons/models/popups';
import * as PopupsActions from '../../../../../store/actions/popups.actions';
import { DialogComponent } from '../../../../shared/components/dialog/dialog.component';


@Component({
    selector: 'app-new-popups',
    templateUrl: './new-popups.component.html',
    styleUrls: ['./new-popups.component.scss']
})
export class NewPopupsComponent {
    private unsubscribe$ = new Subject<void>();
    popupsForm: UntypedFormGroup;
    popups: Popups;
    selectedFile: File | null = null;
    popupImage: string | ArrayBuffer | null = null;

    constructor(
        private store$: Store<AppState>,
        private alertService: AlertService,
        private fb: UntypedFormBuilder,
        private dialog: MatDialog,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        if(this.data) {
            this.popups = this.data.popup
        }

        this._createForm();
        this.ngOnChanges();
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    private _createForm() {
        let popupsGroup = {
            title: ["", Validators.required],
            content: ["", Validators.required],
            start_date: ["", Validators.required],
            end_date: ["", Validators.required],
            image: [null]
        };
    
        this.popupsForm = this.fb.group(popupsGroup);
        // console.log('Form creato con i valori:', this.closuresForm.value);
    
    }

    private ngOnChanges() {
        if (this.popupsForm) {
          this.popupsForm.reset();
          
          this._initFormValues(this.popups);
        }
    }

    private _initFormValues(popups?: Popups) {
        if (popups) {
            
            const startDate = popups.start_date ? new Date(popups.start_date) : null;
            const endDate = popups.end_date ? new Date(popups.end_date) : null;
            const tenantId = this.data?.tenant_id ?? null;
    
            this.popupsForm.patchValue({
                title: popups.title,
                content: popups.content,
                start_date: startDate ? popups.start_date : null,
                end_date: endDate ? popups.end_date : null,
                tenant_id: tenantId
            });
        } 
        else {
            this.popupsForm.get('image').setValidators(Validators.required);
            this.popupsForm.markAllAsTouched();
        }
    }

    previewImage(file: File): void {
        const reader = new FileReader();
        reader.onload = (e: any) => {
            const previewElement = document.getElementById('imagePreview') as HTMLDivElement;
            previewElement.style.backgroundImage = `url(${e.target.result})`;
        };
        reader.readAsDataURL(file);
        this.popupsForm.patchValue({
            image: file
        })
        this.popupsForm.markAsDirty();
    }

    onFileSelected(event: any) {
        const file = event.target.files[0];
        if(!file) return;
        this.selectedFile = file;
        this.popupsForm.patchValue({
            image: file
        })
        this.popupsForm.markAsDirty();
        this.previewImage(file);
    }


    setImagePreview(imageUrl: string): void {
        const previewElement = document.getElementById('imagePreview') as HTMLDivElement;

        if (imageUrl) {
            previewElement.style.backgroundImage = `url(${imageUrl})`;
        } else {
            previewElement.style.backgroundImage = `url(../../../../../../../assets/images/no-image.jpg)`;
        }
    }

     private _prepareSavePopup(): Popups {
        let popup = Popups.fromFormGroup(this.popupsForm, this.popups);
        popup.tenant_id = this.data?.tenant_id;

        return popup
    }

    save() {
        if (!this.popups && !this.selectedFile) {
          let dialogRef = this.dialog.open(DialogComponent, {
            disableClose: false,
          });
    
          dialogRef.componentInstance.title = "Errore";
          dialogRef.componentInstance.confirmMessage = "L'immagine è obbligatoria per la creazione del popup";
    
          return;
        }
    
        let unsavedEntity = this._prepareSavePopup();
        this.store$.dispatch(PopupsActions.savePopup({ popup: unsavedEntity }));
    }
    

    close() {
        if (this.popupsForm.dirty) {
            this.store$.dispatch(PopupsActions.requestClosePopupsDialog());
        } else {
            this.store$.dispatch(PopupsActions.closePopupsDialog());
        }
    }

    deletePopup() {
        if (this.popups) {
            this.store$.dispatch(PopupsActions.deletePopup({ popup: this.popups.toDTO() }));
        }
    }

    resetForm() {
        this.popupsForm.reset();
        this.popupImage = null;
        this.selectedFile = null;
    }
}